function updateClockAlt() {
  const clockElement = document.getElementById('clock-alt');
  const now = new Date();
  const hours = now.getHours();
  const minutes = now.getMinutes();
  const seconds = now.getSeconds();
  const milliseconds = Math.floor(now.getMilliseconds() / 10);
  const formattedTime = `${hours.toString().padStart(2, '0')} : ${minutes.toString().padStart(2, '0')} : ${seconds
    .toString()
    .padStart(2, '0')} : ${milliseconds.toString().padStart(2, '0')}`;
  clockElement.textContent = formattedTime;
}
setInterval(updateClockAlt, 10);
updateClockAlt();
